export default "/_assets/arrow_enabled.1612e153.svg"